<template>
    <div  class="page-warpper indexWork" >
        <div class="part-panel" data-index='song'>
            <h1 class="part-title"></h1>
            <div class="part-body self-bg">
                <div class='part-head'>
                    <div class="head-panel">
                        <a class="head-tab" href="javascript:;" v-bind:class="{' head-select': songOrder == 3 }"  v-on:click="songOrder = 3">最热作品</a>            
                        <a class="separator" href="javascript:;">/</a> 
                        <a class="head-tab " href="javascript:;" v-bind:class="{' head-select': songOrder == 1 }"  v-on:click="songOrder = 1">最新作品</a> 
                    </div>
                    <div class="search-panel clearfix">
                        <input class="search-textbox" type="text" placeholder="输入作品名/作者名/作品编号" v-model="keyword" v-on:keyup="search" />
                        <a class="search-btn" href="javascript:;" v-on:click="search"></a>
                    </div>   
                </div>
                
                <template v-if='songList.length > 0'>
                    <ul class='part-list' >
                        <li  v-for="item in songList">
                            <workItem :columnIndex="0"  :work="item" ></workItem>
                        </li>
                    </ul>
                    <pagination :total="songListTotal" :pageSize="pageSize"  :parentPage="songCurrentPage"   v-on:currentPage="songPage"  v-if='Math.ceil(songListTotal / pageSize) > 1'></pagination>
                </template>
                <template v-else>
                    <div class='no-data' v-if="!isSearch"></div>
                    <div class='no-search' v-else>没有找到相应的作品！</div>
                </template>
                
            </div>
        </div>
        <div class="part-panel" data-index='mv'>
            <h1 class="part-title"></h1>
            <div class="part-body self-bg">
                <div class='part-head'>
                    <div class="head-panel">
                        <a class="head-tab" href="javascript:;" v-bind:class="{' head-select': mvOrder == 4 }"  v-on:click="mvOrder = 4">最热视频</a>            
                        <a class="separator" href="javascript:;">/</a> 
                        <a class="head-tab " href="javascript:;" v-bind:class="{' head-select': mvOrder == 1 }"  v-on:click="mvOrder = 1">最新视频</a> 
                    </div>
                    <div class="search-panel clearfix">
                        <input class="search-textbox" type="text" placeholder="输入作品名/作者名" v-model="keywordMv" v-on:keyup="searchMv" />
                        <a class="search-btn" href="javascript:;" v-on:click="searchMv"></a>
                    </div>
                </div>
                
                <template v-if='mvList.length > 0'>
                    <ul class='part-list mv-ul' >
                        <li  v-for="item in mvList">
                            <workItem :columnIndex="1"  :work="item" ></workItem>
                        </li>
                    </ul>
                    <pagination :total="mvListTotal" :pageSize="mvPageSize" :parentPage="mvCurrentPage"  v-on:currentPage="mvPage"  v-if='Math.ceil(mvListTotal / mvPageSize) > 1'></pagination>
                </template>
                <template v-else>
                    <div class='no-data' v-if="!isSearchMv"></div>
                    <div class='no-search' v-else>没有找到相应的作品！</div>
                </template>
                <!-- <div class='no-data' v-else></div> -->
            </div>
        </div>
        <div class="part-panel">
            <div  class="part-warpper" data-index='sponsor'>
               <div data-index='1'>
                    <h1 class="part-title"></h1>
                    <div class="part-body">
                        <a class="part-item md" href="javascript:void(0);"></a>
                        <a class="part-item kugou" href="javascript:void(0);" ></a>
                        <a class="part-item sing" href="javascript:void(0);"></a>
                    </div>
                </div>
                <div data-index='2'>
                    <h1 class="part-title"></h1>
                    <div class="part-body">
                        <a class="part-item " href="javascript:void(0);"></a>
                    </div>
                </div>
                <div data-index='3'>
                    <h1 class="part-title"></h1>
                    <div class="part-body">
                        <a class="part-item za" href="javascript:void(0);" ></a>
                        <a class="part-item yd" href="javascript:void(0);" ></a>
                        <a class="part-item grt" href="javascript:void(0);" ></a>
                        <a class="part-item sy" href="javascript:void(0);" ></a>
                        <p class='txt'>(排序不分先后)</p>
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import workItem from '@/components/work-item'
import pagination from '@/components/pagination'
export default {
    name: "indexWork",
    data() {
        return {
            signConfig: this.$winConfig.signConfig,
            pageSize: 15,
            mvPageSize: 16,
            songList: [],
            songOrder: 3,
            songListTotal: null,
            songCurrentPage: 1,
            keyword: '',
            keywordMv: '',
            isSearch: false,
            isSearchMv: false,

            mvList: [],
            mvOrder: 4,
            mvListTotal: null,
            mvCurrentPage: 1,
        };
    },
    components: {
        workItem,
        pagination
    },
    created: function () {
        if(this.$route.params.order){
            this.songOrder = this.$route.params.order;
        }else{
            this.getSongList();
        }
        if(this.$route.params.scroll){
            window.scrollTo(0,this.$route.params.scroll);
        }
        this.getMvList();
    },
    watch:{
        songOrder:function(){
            this.songCurrentPage = 1;
            this.getSongList();
            
        },
        mvOrder:function(){
            this.mvCurrentPage = 1;
            this.getMvList();
        },
        keyword: function(val){
            if(val != ''){
                this.isSearch = true;
            }
        },
        keywordMv: function(val){
            if(val != ''){
                this.isSearchMv = true;
            }
        }
    },
    methods:{
        getSongList: function(){
            let _this = this;
            let formData = {
                page: _this.songCurrentPage,
                order: _this.songOrder,
                number: _this.pageSize,
                keyword: _this.keyword
            };
            this.$server.getWorkList(formData).then(function(res){
                _this.songList = res.data;
                _this.songListTotal =  parseInt(res.total);
                //_this.songListTotal =  Math.ceil(res.total / _this.pageSize);
            });
        },
        songPage: function (childValue) {
            this.songCurrentPage = childValue;
            this.getSongList();
        },
        getMvList: function(){
            let _this = this;
            let formData = {
                sid: _this.signConfig[1].id,
                page: _this.mvCurrentPage,
                order: _this.mvOrder,
                number: _this.mvPageSize,
                sign_type: 7,
                keyword: _this.keywordMv
            };
            this.$server.getWorkList(formData).then(function(res){
                _this.mvList = res.data;
                _this.mvListTotal = parseInt(res.total);
            });
        },
        mvPage: function (childValue) {
            this.mvCurrentPage = childValue;
            this.getMvList();
        },
        search: function(event){
            if ("click" === event.type || ("keyup" === event.type && 13 === event.keyCode)) {
                this.songCurrentPage = 1;
                this.getSongList();
            }
        },
        searchMv: function(event){
            if ("click" === event.type || ("keyup" === event.type && 13 === event.keyCode)) {
                this.mvCurrentPage = 1;
                this.getMvList();
            }
        }
    }
};
</script>
<style rel="stylesheet/scss" lang="scss" >
@import "../assets/sass/cmn.scss";
.part-panel{
    .part-head{
        position: relative;
        .head-panel{
            margin-bottom: 20px;
            font-size: 18px;
            .separator{
                display: inline-block;
                padding: 5px 0;
                font-size: 26px;
                color: #e1d5f4;
                vertical-align: middle;
            }
            .head-tab{
                display: inline-block;
                padding:  10px;
                margin: 0 15px;
                color: #e1d5f4;
                vertical-align: top;
            }
            .head-select{
                color: #fff;
                border-bottom: 3px solid #fff;
            }
        }
        .search-panel{
            position: absolute;
            right: 0;
            top: 0;
            width: 300px;
            height: 38px;
            padding: 1px 10px;
            border: 1px solid #542eab;
            border-radius: 5px;
            background-color: rgba(255,255,255,.5);
            .search-textbox{
                width: 270px;
                height: 38px;
                padding: 0;
                line-height: 38px;
                outline: 0;
                border: 0;
                font-size: 14px;
                background-color: transparent;
                &::-webkit-input-placeholder{
                    color:#fff;
                }
                &::-moz-input-placeholder{
                    color:#fff;
                }
                &::-ms-input-placeholder{
                    color:#fff;
                }
            }
            .search-btn{
                position: absolute;
                right: 3%;
                top: 20%;
                display: block;
                width: 21px;
                height: 21px;
                background-image: url(componentsImgPath('index/search.png'));
            }
        }
    }
    
    .part-list{
        width: 990px;
        li{
            display: inline-block;
            margin: 0 31px 20px 0;
        }
    }
    .mv-ul{
        li{
            
            margin: 0 23px 20px 0;
        }
    }
}
.part-panel[data-index="song"]{
    .part-title{
        background-image: url(componentsImgPath('index/title-songTop.png'));
    }
}
.part-panel[data-index="mv"]{
    .part-title{
        background-image: url(componentsImgPath('index/title-mvTop.png'));
    }
}

</style>



// WEBPACK FOOTER //
// src/components/index-work.vue